import React from 'react'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'

interface ModalProps {
  content: JSX.Element
  open: boolean
  handleClose: () => void
}

const TaskModal: React.FC<ModalProps> = ({ content, open, handleClose }) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      {content}
    </Modal>
  )
}

export default TaskModal
